module.exports = __webpack_public_path__ + "img/caret-down.57033b3d.svg";